__turbopack_context__.v({
  "arisLogo": "Es2zrW_arisLogo",
  "header": "Es2zrW_header",
});
